import { GoogleMapApi } from 'app/src/map/utils'
import isNil from 'lodash-es/isNil'

const MAP_PADDING: google.maps.Padding = {
  // Search bar & tools height
  top: 164,
  right: 64,
  // View tools
  bottom: 96,
  left: 64
}

interface Args {
  googleApi: GoogleMapApi
  bounds:
    | google.maps.LatLngBounds
    | {
        sw: google.maps.LatLng
        ne: google.maps.LatLng
      }
  correctedPadding?: number
}

const fitBoundsWithPadding = ({ googleApi: { map, maps }, bounds }: Args) => {
  if (!isNil(map) && !isNil(maps)) {
    const newBounds =
      'sw' in bounds ? new maps.LatLngBounds(bounds.sw, bounds.ne) : new maps.LatLngBounds(bounds)

    if (!isNil(newBounds)) map.fitBounds(newBounds, MAP_PADDING)
  }
}

export default fitBoundsWithPadding
